import { supabase } from "@/lib/supabase";
import type { IAttentionService } from "@/services/interfaces/IAttentionService";
import type { AttentionItem } from "@/features/attention/types";
import { orgImageUrl } from "./orgMapping";

interface Row {
  kind: AttentionItem["kind"]; role: AttentionItem["role"]; severity: AttentionItem["severity"];
  quest_id: string; task_id: string | null; item_count: number;
  since: string | null; due_at: string | null;
  quest_title: string; quest_i18n: AttentionItem["questI18n"]; quest_source_lang: string | null;
  task_title: string | null; task_i18n: AttentionItem["taskI18n"]; task_source_lang: string | null;
  org_name: string | null; org_logo_path: string | null; poster_name: string | null; poster_avatar_url: string | null;
}

/** Reads my_attention_items(): the caller's own items, computed by the one SQL
 *  definition the daily digest also uses (20261007130000_attention_helper). */
export class SupabaseAttentionService implements IAttentionService {
  async listMine(chainId: number): Promise<AttentionItem[]> {
    const { data, error } = await supabase.rpc("my_attention_items", { p_chain_id: chainId });
    if (error) throw new Error(error.message);
    return ((data ?? []) as Row[]).map((r) => ({
      kind: r.kind, role: r.role, severity: r.severity,
      questId: r.quest_id, taskId: r.task_id, count: r.item_count,
      since: r.since, dueAt: r.due_at,
      questTitle: r.quest_title, questI18n: r.quest_i18n, questSourceLang: r.quest_source_lang,
      taskTitle: r.task_title, taskI18n: r.task_i18n, taskSourceLang: r.task_source_lang,
      // Absent until 20261022100000 is applied: the card then shows initials.
      orgName: r.org_name ?? null, orgLogoUrl: orgImageUrl(r.org_logo_path ?? null),
      posterName: r.poster_name ?? null, posterAvatarUrl: r.poster_avatar_url ?? null,
    }));
  }
}
